import React from 'react';

export const PressLogos = ({
  sectionTitle = "Companies who ❤️ real patients",
  subtext = "Your experiences help inform decisions across healthcare—from research to real-world care.",
  backgroundColor = "#ffffff"
}) => {
  return (
    <section
      style={{
        backgroundColor: backgroundColor,
        padding: '80px 0',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        width: '100%',
        maxWidth: '100vw',
        boxSizing: 'border-box',
        overflow: 'hidden',
        position: 'relative'
      }}
    >
      {/* Organic background elements */}
      <div
        style={{
          position: 'absolute',
          top: '0',
          left: '50%',
          transform: 'translateX(-50%)',
          width: '800px',
          height: '200px',
          borderRadius: '50%',
          background: 'radial-gradient(ellipse, rgba(241, 91, 65, 0.04) 0%, transparent 70%)',
          filter: 'blur(30px)',
          pointerEvents: 'none'
        }}
      />

      <div style={{ maxWidth: '1200px', margin: '0 auto', position: 'relative', zIndex: 1, padding: '0 40px' }}>
        {sectionTitle && (
          <p
            style={{
              fontFamily: '"Source Serif Pro", Georgia, serif',
              fontSize: '24px',
              fontWeight: '600',
              color: '#272726',
              textAlign: 'center',
              marginTop: '0',
              marginBottom: '40px'
            }}
          >
            {sectionTitle}
          </p>
        )}
      </div>

      {/* CSS Keyframes for seamless marquee */}
      <style>
        {`
          @keyframes pressMarqueeLeft {
            0% { transform: translateX(0); }
            100% { transform: translateX(-25%); }
          }
          @keyframes pressMarqueeRight {
            0% { transform: translateX(-25%); }
            100% { transform: translateX(0); }
          }
        `}
      </style>

      {/* Row 1 - Scrolls Left */}
      <div style={{ display: 'flex', overflow: 'hidden', marginBottom: '24px' }}>
        <div style={{
          display: 'flex',
          animation: 'pressMarqueeLeft 40s linear infinite',
          alignItems: 'center',
          whiteSpace: 'nowrap'
        }}>
          {[...Array(4)].map((_, setIndex) => (
            <React.Fragment key={setIndex}>
              <img src="/logos/pfizer.svg" alt="Pfizer" style={{ height: '32px', opacity: 0.7, marginRight: '80px', flexShrink: 0, filter: 'grayscale(1)' }} />
              <img src="/logos/merck.svg" alt="Merck" style={{ height: '34px', opacity: 0.7, marginRight: '80px', flexShrink: 0, filter: 'grayscale(1)' }} />
              <img src="/logos/jnj.svg" alt="Johnson & Johnson" style={{ height: '24px', opacity: 0.7, marginRight: '80px', flexShrink: 0, filter: 'grayscale(1)' }} />
              <img src="/logos/abbvie.svg" alt="AbbVie" style={{ height: '34px', opacity: 0.7, marginRight: '80px', flexShrink: 0, filter: 'grayscale(1)' }} />
              <img src="/logos/astrazeneca.svg" alt="AstraZeneca" style={{ height: '36px', opacity: 0.7, marginRight: '80px', flexShrink: 0, filter: 'grayscale(1)' }} />
              <img src="/logos/bms.svg" alt="Bristol-Myers Squibb" style={{ height: '34px', opacity: 0.7, marginRight: '80px', flexShrink: 0, filter: 'grayscale(1)' }} />
              <img src="/logos/sanofi.svg" alt="Sanofi" style={{ height: '34px', opacity: 0.7, marginRight: '80px', flexShrink: 0, filter: 'grayscale(1)' }} />
              <img src="/logos/amazon.svg" alt="Amazon" style={{ height: '28px', opacity: 0.7, marginRight: '80px', flexShrink: 0, filter: 'grayscale(1)' }} />
              <img src="/logos/roche.svg" alt="Roche" style={{ height: '34px', opacity: 0.7, marginRight: '80px', flexShrink: 0, filter: 'grayscale(1)' }} />
              <img src="/logos/lilly.svg" alt="Eli Lilly" style={{ height: '34px', opacity: 0.7, marginRight: '80px', flexShrink: 0, filter: 'grayscale(1)' }} />
              <img src="/logos/novartis.svg" alt="Novartis" style={{ height: '34px', opacity: 0.7, marginRight: '80px', flexShrink: 0, filter: 'grayscale(1)' }} />
              <img src="/logos/salesforce.svg" alt="Salesforce" style={{ height: '32px', opacity: 0.7, marginRight: '80px', flexShrink: 0, filter: 'grayscale(1)' }} />
            </React.Fragment>
          ))}
        </div>
      </div>

      {/* Row 2 - Scrolls Right */}
      <div style={{ display: 'flex', overflow: 'hidden' }}>
        <div style={{
          display: 'flex',
          animation: 'pressMarqueeRight 45s linear infinite',
          alignItems: 'center',
          whiteSpace: 'nowrap'
        }}>
          {[...Array(4)].map((_, setIndex) => (
            <React.Fragment key={setIndex}>
              <img src="/logos/novonordisk.svg" alt="Novo Nordisk" style={{ height: '44px', opacity: 0.7, marginRight: '80px', flexShrink: 0, filter: 'grayscale(1)' }} />
              <img src="/logos/gsk.svg" alt="GSK" style={{ height: '34px', opacity: 0.7, marginRight: '80px', flexShrink: 0, filter: 'grayscale(1)' }} />
              <img src="/logos/takeda.svg" alt="Takeda" style={{ height: '34px', opacity: 0.7, marginRight: '80px', flexShrink: 0, filter: 'grayscale(1)' }} />
              <img src="/logos/gilead.svg" alt="Gilead" style={{ height: '34px', opacity: 0.7, marginRight: '80px', flexShrink: 0, filter: 'grayscale(1)' }} />
              <img src="/logos/amgen.svg" alt="Amgen" style={{ height: '34px', opacity: 0.7, marginRight: '80px', flexShrink: 0, filter: 'grayscale(1)' }} />
              <img src="/logos/bayer.svg" alt="Bayer" style={{ height: '34px', opacity: 0.7, marginRight: '80px', flexShrink: 0, filter: 'grayscale(1)' }} />
              <img src="/logos/medtronic.svg" alt="Medtronic" style={{ height: '32px', opacity: 0.7, marginRight: '80px', flexShrink: 0, filter: 'grayscale(1)' }} />
              <img src="/logos/bi.png" alt="Boehringer Ingelheim" style={{ height: '34px', opacity: 0.7, marginRight: '80px', flexShrink: 0, filter: 'grayscale(1)' }} />
              <img src="/logos/regeneron.svg" alt="Regeneron" style={{ height: '22px', opacity: 0.7, marginRight: '80px', flexShrink: 0, filter: 'grayscale(1)' }} />
              <img src="/logos/moderna.svg" alt="Moderna" style={{ height: '30px', opacity: 0.7, marginRight: '80px', flexShrink: 0, filter: 'grayscale(1)' }} />
              <img src="/logos/biogen.svg" alt="Biogen" style={{ height: '34px', opacity: 0.7, marginRight: '80px', flexShrink: 0, filter: 'grayscale(1)' }} />
            </React.Fragment>
          ))}
        </div>
      </div>

      {/* Subtext */}
      <div style={{ maxWidth: '1200px', margin: '0 auto', position: 'relative', zIndex: 1, padding: '0 40px' }}>
        {subtext && (
          <p
            style={{
              fontSize: '16px',
              color: '#4A4A4A',
              textAlign: 'center',
              marginTop: '48px',
              marginBottom: '0',
              maxWidth: '600px',
              marginLeft: 'auto',
              marginRight: 'auto',
              lineHeight: '1.6'
            }}
          >
            Your experiences help{' '}
            <span style={{ position: 'relative', display: 'inline-block' }}>
              <span
                style={{
                  position: 'absolute',
                  left: '-2%',
                  right: '-2%',
                  bottom: '0',
                  height: '40%',
                  background: 'linear-gradient(90deg, rgba(235, 160, 155, 0.7) 0%, rgba(245, 185, 165, 0.65) 40%, rgba(250, 200, 160, 0.6) 70%, rgba(245, 215, 170, 0.5) 100%)',
                  transform: 'skewX(-1deg)',
                  zIndex: 0,
                  borderRadius: '2px'
                }}
              />
              <span style={{ position: 'relative', zIndex: 1 }}>inform decisions</span>
            </span>
            {' '}across healthcare—from research to real-world care.
          </p>
        )}
      </div>
    </section>
  );
};
